/* eslint-disable react/jsx-no-target-blank */
import { Modal } from 'antd';

export default function ModalCheckHearing({ showChangeWarning, setShowChangeWarning }: any) {

  const modalSetting: any = {
    footer: false,
    centered: true,
    closable: false,
    className: 'modal-emotion',
  };

  let first_text: any;
  let second_text: any;
  first_text = (
    <>
      本人認証が完了していないため<br />
      サービスの利用が限定されています。
    </>
  );

  second_text = (
    <>
      本人認証が完了していない場合、<br />
      依頼予約などの各サービスを <br />
      ご利用いただけくことができません。<br />
      本人認証が完了するまでお待ちください。
    </>
  );

  const handleCancel = (): void => {
    setShowChangeWarning(false);
  };

  return (
    <>
      {/* {showPopup} */}
      <div className={`emotion-modal customer-verify `}>
        <Modal open={showChangeWarning} onCancel={handleCancel} {...modalSetting}>
          <div className={`modal-container-emotion kyc-hearing-modal-success-wrapper`}>
            <div className={`text-emotion-description customer-item item-hearing-first`}>
              <h2 className="text-emotion-first ">{first_text}</h2>
              {second_text === '' ? '' : <p className={'text-emotion-second'}>{second_text}</p>}
            </div>

            <div className="btn-bottom-emotion" style={{marginTop: '80px'}}>
              <button className="btn btn-small btn-check" onClick={handleCancel}>
                閉じる
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
